import { Icon } from "metabase/ui";

const FieldSeparator = () => {
  return <Icon name="chevronright" size={12} className="mx2 text-medium" />;
};

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default FieldSeparator;
